import {
  ApplicationType,
  DataSourceType,
} from "@/views/customize/data-sources/data/model";
import { FindingObjectType } from "./api/findings/findings.model";
import { SERVICE, POPULATION_TYPE } from "./models";
import { UserRole } from "@/views/admins/data/models";
import { DATA_SOURCES_MAP } from "@/views/customize/data-sources/data/data-relations/data-sources.map";
import { SourceApplicationsDescriptors } from "@/views/customize/data-sources/data/data-relations/applicaitons.map";
export const ICONS = {
  L0_ICONS: {
    get(code: number) {
      switch (code) {
        case 1: //"d5f24583-7595-6d41-0760-a5d11b8be7cf":
          return "Other";
        case 2: //"2ef1d9da-0ad7-450e-4b09-efd43581ce78":
          return "Governance";
        case 3: //"e2bd11ab-9869-5adc-f11c-7d05c7c6fc2b":
          return "Business";
        case 4: // "fd6a3357-4b1f-df40-d9f5-731e35302fe5":
          return "Finance";
        case 5: //"707babad-231f-82bb-014c-8506d3dc784e":
          return "HR";
        case 6: //"e34ebd2f-cd96-22ac-3059-952a7fe01e54":
          return "Legal";
        case 7: //"a9383d32-7694-4d84-b37c-79afb945505b":
          return "Regulated";
        default:
          return "Label";
      }
    },
  },
  APPLICATIONS: {
    get(id: ApplicationType | string) {
      switch (id) {
        case "onedrive":
          return "OneDrive";
        case "sharepoint":
          return "SharePoint";
        case "exchange_365":
          return "Exchange";
        case "ms_teams":
          return "Teams";
        default:
          return SourceApplicationsDescriptors[id as ApplicationType]
            ? SourceApplicationsDescriptors[id as ApplicationType].icon
            : "";
      }
    },
  },
  SENSITIVITIES: {
    get(level: number): string {
      switch (level) {
        case 1:
        case 0.2:
          return "Sensitivity_L";
        case 2:
        case 0.5:
          return "Sensitivity_M";
        case 3:
        case 0.85:
          return "Sensitivity_H";
        case 0:
        default:
          return "Sensitivity_N";
      }
    },
  },
  SEVERITIES: {
    get(level: number): string {
      switch (level) {
        case 1:
        case 0.2:
          return "Severity_L";
        case 2:
        case 0.5:
          return "Severity_M";
        case 3:
        case 0.85:
          return "Severity_H";
        case 0:
        default:
          return "Severity_N";
      }
    },
  },
  INFO_AT_REST: {
    get(id: string): string {
      switch (id) {
        case "aws":
          return "aws";
        case "azure":
          return "azure";
        case "sharepoint":
          return "SharePoint";
        case "end-points":
          return "EndPoints";
        case "on-prem":
        default:
          return "Container";
      }
    },
  },
  ROLE: {
    get(role: UserRole) {
      switch (role) {
        case UserRole.ADMIN:
          return "Admin";
        case UserRole.SUPER_ADMIN:
        default:
          return "SuperAdmin";
      }
    },
  },
  SERVICE_PROVIDER: {
    get(p: string): string {
      switch (p) {
        case "gmail":
          return "Gmail";
        case "mso365-exchange":
        default:
          return "Ms";
      }
    },
  },
  SERVICE: {
    byNumber(num: SERVICE) {
      switch (num) {
        case SERVICE.GMAIL:
          return "Gmail";
        case SERVICE.ONEDRIVE:
          return "OneDrive";
        case SERVICE.EXCHANGE365:
          return "Exchange";
        case SERVICE.TEAMS:
          return "Teams";
        case SERVICE.SHAREPOINT:
          return "SharePoint";
        case SERVICE.DROPBOX:
          return "DropBox";
        default:
          return "";
      }
    },
    byString(service: string, colorful = false) {
      const lower = service.toLowerCase();
      switch (lower) {
        case "gmail":
          return colorful ? "GmailColor" : "Gmail";
        case "gdrive":
          return colorful ? "GdriveColor" : "Gdrive";
        case "gchat":
          return colorful ? "GChat" : "GChat";
        case "onedrive":
        case "mso365-OneDrive":
          return "OneDrive";
        case "exchange":
        case "exchange_365":
        case "exchange365":
        case "mso365-exchange":
          return "Exchange";
        case "teams":
        case "ms_teams":
        case "mso365-teams":
          return "Teams";
        case "sharepoint":
        case "share_point":
        case "mso365-sharepoint":
          return "SharePoint";
        case "dropbox":
          return "DropBox";
        default:
          return "";
      }
    },
  },
  FINDINGS_OBJECT_TYPE(t: FindingObjectType) {
    switch (t) {
      case "File":
        return "File";
      case "Folder":
        return "Folder";
      case "Person":
        return "User";
      case "Organization":
        return "Organization";
      case "Group":
        return "Department";
      default:
        return "";
    }
  },
  DATA_SOURCES: {
    get(id: DataSourceType) {
      return DATA_SOURCES_MAP[id].icon;
    },
  },
  ENTITIES: {
    get(
      type:
        | POPULATION_TYPE
        | "CONTAINER"
        | "SERVER"
        | "STORAGE"
        | "DATA_BASE"
        | "EMPLOYEE_SENDER"
        | "EMPLOYEE_RECEIVER"
    ): string {
      switch (type) {
        case POPULATION_TYPE.FILE:
          return "File";
        case POPULATION_TYPE.CONTACT:
          return "External";
        case POPULATION_TYPE.EMPLOYEE:
        case "EMPLOYEE_SENDER":
        case "EMPLOYEE_RECEIVER":
          return "User";
        case POPULATION_TYPE.ORGANIZATION:
          return "Organization";
        case POPULATION_TYPE.GROUP:
          return "Group";
        case POPULATION_TYPE.LABEL:
        case POPULATION_TYPE.CONTEXT:
          return "Label";
        case POPULATION_TYPE.PRIVATE_EMAIL:
          return "PrivateEmail";
        case POPULATION_TYPE.EVENT:
          return "Events";
        case POPULATION_TYPE.DEPARTMENT:
          return "Department";
        case "CONTAINER":
        case "DATA_BASE":
          return "DB";
        case "SERVER":
          return "Server";
        case "STORAGE":
          return "Container";
        case POPULATION_TYPE.FOLDER:
        default:
          return "Folder";
      }
    },
  },
  EXTENSION: {
    get(extension: string): string {
      switch (extension.toLowerCase()) {
        case "docx":
        case "doc":
          return "doc";
        case "xlsx":
        case "xls":
          return "xls";
        case "pdf":
          return "pdf";
        case "ppt":
        case "pptx":
          return "ppt";
        default:
          return "File";
      }
    },
  },
  FOLDER_CONTEXT: {
    get_by_category(name: string): string {
      const lower_case = name.toLowerCase();
      switch (true) {
        case lower_case.includes("project"):
          return "File";

        case lower_case.includes("data room"):
          return "External";

        case lower_case.includes("other"):
          return "User";

        case lower_case.includes("intellectual property"):
          return "Organization";

        case lower_case.includes("sales"):
          return "Events";

        case lower_case.includes("marketing"):
          return "Label";

        case lower_case.includes("product and r&d"):
          return "Admin";

        default:
          return "Folder";
      }
    },
  },
};
